
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/panel",
      function () {
        return require("private-next-pages/panel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/panel"])
      });
    }
  